export type VehicleCategory = 'CAR' | 'VAN' | 'HGV' | 'BUS' | 'OTHER';

export const VEHICLE_CATEGORIES: VehicleCategory[] = ['CAR', 'VAN', 'HGV', 'BUS', 'OTHER'];

export interface DealerPrice {
	vehicleCategory: VehicleCategory;
	registrationYear: number | null;
	pricePennies: number;
}
